import { HTML_ELEMENT_TAB_INDEX_NOT_TABABLE } from '../../../constants/html'
import { stopPropagation } from '../../../utils/events'
import { ButtonArrow as ButtonArrowComponent } from '../../Button'
import { InputClearButton } from '../../Input'
import { useSelectContext } from '../Select.hooks'

import { isNeedToShowClearButton } from './SelectControlIndicators.utils'

import * as styles from './SelectControlIndicators.module.css'

function SelectControlIndicators({
  ButtonArrow = ButtonArrowComponent,
  ButtonClear = InputClearButton,
  Element = 'div',
  InfoIcon,
  SelectedItemsCounter,
  SymbolCounter,
  buttonArrowProps,
  checkIsNeedToShowClearButton = isNeedToShowClearButton,
  className = styles.SelectControlIndicators,
  clearButtonProps,
  infoIconProps,
  ref,
  selectedItemsCounterProps,
  symbolCounterProps,
  ...restProps
}) {
  const {
    blocked,
    disabled,
    handleClear,
    handleClearSearch,
    handleToggleOpen,
    isOpen,
    multi,
    searchValue,
    value,
  } = useSelectContext()

  function handleClickClear(event) {
    stopPropagation(event)

    if (searchValue) {
      handleClearSearch()
    } else {
      handleClear(event)
    }
  }

  const showClearButton = checkIsNeedToShowClearButton({
    ButtonClear,
    blocked,
    disabled,
    handleClear,
    multi,
    searchValue,
    value,
  })

  return (
    <Element {...restProps} className={className} ref={ref}>
      {SelectedItemsCounter ? (
        <SelectedItemsCounter {...selectedItemsCounterProps} />
      ) : null}
      {InfoIcon ? <InfoIcon {...infoIconProps} /> : null}
      {showClearButton ? (
        <ButtonClear
          {...clearButtonProps}
          tabIndex={HTML_ELEMENT_TAB_INDEX_NOT_TABABLE}
          onClick={handleClickClear}
        />
      ) : null}
      {SymbolCounter ? (
        <SymbolCounter {...symbolCounterProps} value={searchValue} />
      ) : null}
      {ButtonArrow && !blocked && !disabled ? (
        <ButtonArrow
          {...buttonArrowProps}
          isOpen={isOpen}
          tabIndex={HTML_ELEMENT_TAB_INDEX_NOT_TABABLE}
          onClick={handleToggleOpen}
        />
      ) : null}
    </Element>
  )
}

export default SelectControlIndicators
